import {api} from '../../system/api';

export default {
    getHistories: (params) => api.get('barcode-scannings', {params}, {singleRequest: true}),
};
